/**
 * Concept angle type constants
 * These constants should be kept in sync with the API ConceptAngleTypeEnum
 */

export const ConceptAngleType = {
  MAIN: 'main',
  DERIVATIVE: 'derivative',
} as const;

export type ConceptAngleTypeType =
  (typeof ConceptAngleType)[keyof typeof ConceptAngleType];
